import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6fae414a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { class: "page__container" };
import ListHeader from "@/components/ListHeader.vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        hasHeader: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.hasHeader)
                    ? (_openBlock(), _createBlock(ListHeader, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
                        "filters:menu": _withCtx(() => [
                            _renderSlot(_ctx.$slots, "header:filters:menu")
                        ]),
                        filters: _withCtx(() => [
                            (_ctx.$slots['header:filters'])
                                ? _renderSlot(_ctx.$slots, "header:filters", { key: 0 })
                                : _createCommentVNode("", true)
                        ]),
                        title: _withCtx(() => [
                            (_ctx.$slots['header:title'])
                                ? _renderSlot(_ctx.$slots, "header:title", { key: 0 })
                                : _createCommentVNode("", true)
                        ]),
                        _: 3
                    }, 16))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ]));
        };
    }
});
